import React, {useState, useEffect} from 'react';
import Slider from 'react-slick';
import useGet from "../hooks/useGet";
import useExp360Script from "../hooks/useExp360Script";
import {destroyPlayer, initPlayer, open360content} from "../utils/exp360Utils";
import {getExcursionText} from "../utils/themeUtils";

function Exp360VideoPlayerSimple(props) {
    const {isScriptLoaded, scriptError} = useExp360Script();
    const [videoError, setVideoError] = useState(false)
    const playerId = "exp360-video-container";


    // fetch video ids from exp360 API
    const bundleResponse = useGet(`https://embed.exp360.com/assets/bundle/01552ffb-882e-48a8-9351-0e4836b0a284/${props.bundleId}`);
    const videos = bundleResponse ? bundleResponse.contents : false;

    // create the player element
    useEffect(() => {
        if(isScriptLoaded && videos) {
            if(videos.length) {
                initPlayer(playerId, videos[0].id);
            }
            else {
                setVideoError(true);
            }
        }

        return destroyPlayer;
    }, [isScriptLoaded, videos]);

    if(scriptError) {
        return (
            <ErrorMessage message="There has been an error with loading the 360 video player. Please try again later." />
        )
    }

    if(videoError) {
        return (
            <ErrorMessage message={`The video content for this ${getExcursionText()} could not be loaded, please try again later.`} />
        )
    }

    if(!isScriptLoaded) {
        return null;
    }


    const sliderOptions = {
        dots: true,
        infinite: (videos && videos.length > 4),
        speed: 500,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        swipe:false,
    };

    return (
        <div className="bg-transparent w-full">
            <div>
                {/* the actual video player*/}
                <div className="sm:w-3/4 md:w-full mx-auto">
                    <div className="container-2-1">
                        <div id={playerId} className="container-2-1-img"></div>
                    </div>
                </div>

                {/* the thumbnails of videos */}
                {videos && videos.length > 1 &&
                <div className="max-w-full mt-8">
                    <Slider {...sliderOptions}>
                        {videos.map(video =>
                            <div key={video.id} className="w-48 mx-2 outline-hidden">
                                <img className="cursor-pointer" src={`https://embed.exp360.com/assets/thumbnail/${video.id}/200/125`}
                                     alt={video.title}
                                     onClick={() => open360content(video.id)}/>
                            </div>
                        )}
                    </Slider>
                </div>
                }
            </div>
        </div>
    );
}

export default Exp360VideoPlayerSimple;

function ErrorMessage(props) {
    return (
        <div className="flex justify-center items-center bg-white py-4 px-2 sm:px-4">
            <div>
                {props.message}
            </div>
        </div>
    )
}
